import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
} from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { InvoiceReviewSummaryService } from "../../../core/services/invoice-review-summary.service";
import { ShippingMethod } from "../../../core/models/shared/shippingMethod";
import { GetIRHeaderResponse } from "../../../core/models/invoice-review/getInvoiceReviewHeaderResponse";
import { UpdateProjectInvoiceReviewDetailsRequestDto } from "../../../core/models/invoice-review/UpdateProjectInvoiceReviewDetailsRequestDto";
import { LoaderService } from "../../../core/services/loader.service";
import { SamplepoListingService } from "../../../core/services/samplepo-listing.service";
import { JniToastrService } from "../../../core/services/jni-toastr.service";
import { ModalStackerComponent } from "../../../shared/components/modal-stacker/modal-stacker.component";
import { FreightChargesComponent } from "../../orders/components/freight-charges/freight-charges.component";
import { InvoiceReviewClientDepositComponent } from "../client-deposit/client-deposit.component";
import { ClientDetailsComponent } from "../../clients/components/client-details/client-details.component";
import { OrderSummaryComponent } from "../../orders/components/order-summary/order-summary.component";
import { CommonModule } from "@angular/common";
import { SelectModule } from "primeng/select";
import { FormsModule } from "@angular/forms";
import { HidedynamicsdatePipe } from "../../../shared/pipes/hidedate/hidedynamicsdate.pipe";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";

@UntilDestroy()
@Component({
  selector: "jni-invoice-review-order-details",
  templateUrl: "./invoice-review-order-details.component.html",
  styleUrls: ["./invoice-review-order-details.component.scss"],
  imports: [
    ModalStackerComponent,
    FreightChargesComponent,
    InvoiceReviewClientDepositComponent,
    ClientDetailsComponent,
    OrderSummaryComponent,
    CommonModule,
    SelectModule,
    FormsModule,
    HidedynamicsdatePipe,
    ButtonModule,
    CardModule,
    InputTextModule,
  ],
})
export class InvoiceReviewOrderDetailsComponent implements OnInit {
  @Input() salesOrderId = "";

  clientId = "";
  orderDisplayModal = false;
  clientDisplayModal = false;
  freightChargesDisplayModal = false;
  clientDepositDisplayModal = false;
  shippingProductsList: ShippingMethod[] = [];
  invoicereviewHeaderResponse!: GetIRHeaderResponse;
  shippingMethodCode = "";
  invoiceReviewNumber = "";
  jobName = "";
  customerPONumber = "";
  @Output() updatePdfEvent = new EventEmitter();

  constructor(
    private _samplepoListingService: SamplepoListingService,
    private _loaderService: LoaderService,
    private _toastrService: JniToastrService,
    private _invoiceReviewSummaryService: InvoiceReviewSummaryService,
    private renderer: Renderer2
  ) {}
  ngOnInit(): void {
    this.getAllShippingMethod();
    this.getInvoiceReviewHeader(true);
  }

  onOrderSelection(saleOrderId: string) {
    if (saleOrderId) {
      this.salesOrderId = saleOrderId;
      this.orderDisplayModal = true;
    }
  }

  onClientSelection(clientId: string) {
    if (clientId) {
      this.clientId = clientId;
      this.clientDisplayModal = true;
    }
  }

  closeModalForClient() {
    this.clientDisplayModal = false;
  }

  closeModalForSaleOrder() {
    this.orderDisplayModal = false;
  }

  addScollHiddenClass() {
    // ToDo List Remove or Add Implementation
  }

  closeModalForFreight() {
    this.freightChargesDisplayModal = false;
  }

  redirectToFreightChargesPage() {
    this.freightChargesDisplayModal = true;
  }

  redirectToClientDepositPage() {
    this.clientDepositDisplayModal = true;
  }

  closeModalForClientDeposit() {
    this.clientDepositDisplayModal = false;
  }

  getAllShippingMethod() {
    this._samplepoListingService
      .getAllShippingMethod()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          const shippingData = res.data;
          this.shippingProductsList = shippingData.filter(
            x => x.jniUseOnSalesOrderD365 !== "No"
          );
        },
      });
  }

  // onShippingMethodChangeTitle(onShippingMethodChange: any) {
  //   const data = this.shippingProductsList.filter(
  //     (x) => x.modeCodeD365 == onShippingMethodChange
  //   )[0];
  //   if (data) {
  //     return data.modeDescriptionD365;
  //   }
  //   return '';
  // }

  getInvoiceReviewHeader(getloaderStatus: boolean) {
    if (this.salesOrderId) {
      this._loaderService.setLoaderState(getloaderStatus);
      this._invoiceReviewSummaryService
        .getIRHeader(this.salesOrderId)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            if (res.data) {
              this.invoicereviewHeaderResponse = res.data;
              this.shippingMethodCode =
                this.invoicereviewHeaderResponse.ShippingMethodCode || "";
              this.jobName = this.invoicereviewHeaderResponse.JobName || "";
              this.customerPONumber = this.invoicereviewHeaderResponse.ClientPO;
            } else {
              this._toastrService.error(
                "Error",
                res.message || "Data not found"
              );
            }
          },
          error: res => {
            this._loaderService.setLoaderState(false);
            this._toastrService.error("Error", res.message || "Data not found");
          },
        });
    }
  }

  updateProjectInvoiceReviewDetails() {
    const invoicePreviewStatusObject = {
      SalesOrderNumber: this.salesOrderId,
      FreightMethodCode: this.shippingMethodCode,
      JobName: this.jobName,
      ClientPO: this.customerPONumber,
    } as UpdateProjectInvoiceReviewDetailsRequestDto;
    this._invoiceReviewSummaryService
      .updateProjectInvoiceReviewDetails(invoicePreviewStatusObject)
      .subscribe({
        next: res => {
          if (res.data.Status.toLowerCase() === "success") {
            this._toastrService.success(
              "Success",
              res.message || `Update successfully`
            );
            this.getInvoiceReviewHeader(true);
            this.updatePdfEvent.emit();
          } else {
            this._toastrService.error(
              "Error",
              res?.message || `Error while updating`
            );
          }
        },
        error: () => {
          this._toastrService.error("Error", `Error while updating`);
        },
      });
  }

  scrollHiddenStatus() {
    setTimeout(() => {
      this.renderer.removeClass(document.body, "p-overflow-hidden");
    }, 0);
  }
}
